import type { ComponentPropsWithRef } from "react";

import { cn } from "@/lib/utils";

type ProductGridProps = ComponentPropsWithRef<"div">;

export default function ProductGrid({
  children,
  className,
  ...props
}: ProductGridProps) {
  return (
    <div
      className={cn(
        "grid w-full gap-x-[1px] max-md:grid-cols-2 md:max-lg:grid-cols-3 lg:grid-cols-4",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
